import { RVRoutingPage } from "@regal-voice/ui";

import { OrchestrationSubNav } from "./Components/OrchestrationSubNav/OrchestrationSubNav";
export default function OrchestrationRoutingPage(): JSX.Element {
    return <RVRoutingPage nav={<OrchestrationSubNav />} />;
}
